import { Helmet } from 'react-helmet';

import PageLayout from '../../layouts/PageLayout';
import Header from './blocks/Header';
import Matches from './blocks/Matches';
import Video from './blocks/Video';

import topVisual from '../../assets/images/ontknoping-top.jpg';
import matchesVisual from '../../assets/images/ontknoping-matches.jpg';
import video from '../../assets/videos/ontknoping.mp4';
import videoPoster from '../../assets/images/espn_watch_poster.avif';
import { useEffect } from 'react';
import { pageView } from '../../scripts/analytics';

const Ontknoping = () => {
    useEffect(() => {
        pageView('ontknoping');
    }, []);

    return (
        <PageLayout theme="dark">
            <Helmet>
                <title>
                    ESPN - Waar kan ik de ontknoping van de Eredivisie zien?
                </title>
                <meta
                    name="description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta
                    property="og:title"
                    content="ESPN - Waar kan ik de ontknoping van de Eredivisie zien?"
                />
                <meta
                    property="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header image={topVisual} />
            <Matches image={matchesVisual} />
            <Video video={video} poster={videoPoster} />
        </PageLayout>
    );
};

export default Ontknoping;
